import {ModalSize, SuiModalService} from '@angular-ex/semantic-ui';
import {Component, OnInit, ViewChild} from '@angular/core';
import {Router} from '@angular/router';
import {Link} from '../../../../core/models/articles/articles.model';

import {Institution} from '../../../../core/models/institutions/institutions.model';
import {Topic} from '../../../../core/models/topics/topics.model';
import {ArticlesService} from '../../../../core/services/articles/articles.service';
import {InstitutionsService} from '../../../../core/services/institutions/institutions.service';
import {ToastService} from '../../../../core/services/toast/toast.service';
import {TopicsService} from '../../../../core/services/topics/topics.service';
import {splitTopics} from '../../../../core/utils/topics.helper';
import {ArticleFormComponent} from '../../../../shared/forms/article-form/article-form.component';
import {DuplicateModal} from '../../components/duplicate-modal/duplicate-modal.component';

@Component({
  selector: 'app-create-article',
  templateUrl: './create-article.component.html',
  styleUrls: ['./create-article.component.css'],
  standalone: false,
})
export class CreateArticleComponent implements OnInit {
  @ViewChild('articleFormComponent', {static: true}) articleForm!: ArticleFormComponent;
  public topics!: Topic[];
  public subjectAreas!: Topic[];
  public institutions!: Institution[];

  constructor(
    private router: Router,
    private topicsService: TopicsService,
    private articlesService: ArticlesService,
    private modalService: SuiModalService,
    private institutionsService: InstitutionsService,
    private toastService: ToastService,
  ) {
  }

  ngOnInit() {
    this.topicsService.getAll({
      select: ['name', 'englishName', 'kind', 'isSubjectArea'],
    }).subscribe(res => {
      const split = splitTopics(res.docs);
      this.topics = split.topics;
      this.subjectAreas = split.subjectAreas;
    });
    this.getInstitutions();
  }

  public createArticle(draft: boolean): void {
    // Build filter with links from new article logical or
    // If there are articles with same link show popup with them
    this.articlesService.getAll({
      only: '',
      links: this.articleForm.getValues().links.map((l: Link) => l.url),
      select: ['title', 'englishTitle', 'createdBy', 'updatedAt', 'links'],
      populate: ['createdBy:firstname;lastname;email'],
    }).subscribe((articlesData) => {
      const duplicates = articlesData.docs;
      if (duplicates.length > 0) {
        // There are possible duplicates -> Open modal with duplicates
        this.modalService
          .open(new DuplicateModal(duplicates, ModalSize.Large))
          .onApprove(() => {
            // user decides that the article is not a duplicate -> add article
            this.postArticle(draft);
          })
          .onDeny(() => {
            // user decides that the article is a duplicate
            this.toastService.warning(
              $localize`:@@articles-not-added-title:Artikel nicht hinzugefügt`,
              $localize`:@@articles-not-added-message:Der Artikel konnte nicht hinzugefügt werden.`);
          });

      } else {
        // There are no possible duplicates -> add article
        this.postArticle(draft);
      }
    });
  }

  private postArticle(isDraft: boolean): void {
    this.articlesService.createOne({
      ...this.articleForm.getValues(),
      isDraft,
    }).subscribe(() => {
      this.toastService.success(
        $localize`:@@articles-create-success-title:Artikel erstellt`,
        $localize`:@@articles-create-success-message:Der Artikel wurde erfolgreich erstellt.`);
      this.router.navigate(['author/articles']);
    }, error => {
      this.toastService.error(
        $localize`:@@articles-create-error-title:Artikel nicht erstellt`,
        $localize`:@@articles-create-error-message:Der Artikel konnte nicht erstellt werden.`,
        error);
    });
  }

  private getInstitutions() {
    this.institutionsService.getAll({
      select: ['name'],
    }).subscribe((instData) => {
      this.institutions = instData.docs;
    });
  }
}
